'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ComboButton = require('./components/ComboButton.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ComboButton).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-combo-button/lib/index.js
// module id = 1060
// module chunks = 1